<div class="ap-tabs" [ngClass]="{ 'ap-tabs--centered': isTabAlignmentCentered() }">
    <nav class="ap-tabs__header">
        <div class="tabs-holder" role="tablist">
            @for (tab of tabs(); track tab; let index = $index) {
                <button
                    role="tab"
                    class="ap-tabs__header__item"
                    (click)="setActiveItem(index)"
                    (keydown)="onKeydown($event, index)"
                    [class.active]="tab.active"
                    [attr.aria-label]="tab.title()"
                    [attr.aria-selected]="tab.active"
                    [tabindex]="tab.active ? 0 : -1"
                    [attr.aria-controls]="tab.id()"
                    data-testid="tabs-tab"
                >
                    @if (tab.customTabLabel) {
                        <ng-template [cdkPortalOutlet]="tab.customTabLabel"></ng-template>
                    }
                    @if (!tab.customTabLabel) {
                        {{ tab.title() }}
                    }
                </button>
            }
        </div>
    </nav>
    <ng-content></ng-content>
</div>
